import React from "react";

class AppErrorBoundary extends React.Component {
    state = {
        hasError: false,
        error: null,
    };

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Unhandled React rendering error", error, errorInfo);

        // Send this to your error-monitoring service if applicable.
        // reportError(error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <>
                <div className="page-error-container">
                    <div className="page-error header">
                        <h1>Oops...</h1>
                        <p>We have encountered an error.</p>
                    </div>
                    <div className="page-error">
                        <p>Please report the following error to the support team, along with as much information as you can about what you were doing when the error occurred.</p>
                        <p>ERROR MESSAGE: {this.state.error?.message}</p>
                        <p>PAGE URL: {window.location.href}</p>
                    </div>
                </div>

                <div className="page-error-container">
                    <p>Once you have reported the error, refreshing the page should get you back up an running.</p>
                </div>
            </>
            );
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
